import { Select } from '@ludus/ui'
import { useTranslation } from 'react-i18next'
import type { PeriodPreset } from '../../types.ts'

interface FilterByPeriodProps {
  value: PeriodPreset
  onChange: (next: PeriodPreset) => void
}

export function FilterByPeriod({ value, onChange }: FilterByPeriodProps) {
  const { t } = useTranslation()

  const options = [
    {
      value: 'today' as const,
      label: t('pages.pipelines.filters.periodToday', { defaultValue: 'Today' }),
    },
    {
      value: '7d' as const,
      label: t('pages.pipelines.filters.period7d', { defaultValue: 'Last 7 days' }),
    },
    {
      value: '30d' as const,
      label: t('pages.pipelines.filters.period30d', { defaultValue: 'Last 30 days' }),
    },
    {
      value: 'all' as const,
      label: t('pages.pipelines.filters.periodAll', { defaultValue: 'All time' }),
    },
  ]

  return (
    <Select<PeriodPreset>
      value={value}
      options={options}
      onValueChange={onChange}
      className="w-full min-w-0 sm:w-auto sm:min-w-[140px]"
    />
  )
}
